/**
 * Standardized Sentry error_type tag values.
 * Used to categorize errors in Sentry for filtering and alerting.
 */
export enum SENTRY_ERROR_TYPE {
  /** UI displays "[PTP] Something went wrong" */
  UI_CRASH = 'ui-crash',
}
